import * as React from "react";
import {PlixEditor} from "../editor/PlixEditor";

export const App = () => {
    return (
        <PlixEditor/>
    )
}